/** 연간시간표가 구독하는 사전 설정(학사일정·수업시간·편제·시간표 설정) 저장 알림 */

export const ANNUAL_PREREQUISITE_REFRESH_EVENT = 'cp:annual-prerequisite-refresh';

export type AnnualPrerequisiteScope =
  | 'academic_calendar'
  | 'class_schedule'
  | 'grade_track'
  | 'timetable_settings';

export type AnnualPrerequisiteRefreshDetail = {
  workspaceId: string;
  scopes: AnnualPrerequisiteScope[];
};

export function emitAnnualPrerequisiteRefresh(
  workspaceId: string,
  scopes: AnnualPrerequisiteScope[]
): void {
  if (typeof window === 'undefined' || !workspaceId || scopes.length === 0) return;
  window.dispatchEvent(
    new CustomEvent<AnnualPrerequisiteRefreshDetail>(ANNUAL_PREREQUISITE_REFRESH_EVENT, {
      detail: { workspaceId, scopes },
    })
  );
}
